import { render, staticRenderFns } from "./RandomAssignments.vue?vue&type=template&id=e362ab36&scoped=true"
import script from "./RandomAssignments.vue?vue&type=script&lang=ts"
export * from "./RandomAssignments.vue?vue&type=script&lang=ts"
import style0 from "./RandomAssignments.vue?vue&type=style&index=0&id=e362ab36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e362ab36",
  null
  
)

export default component.exports